import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M12 4.485a5.25 5.25 0 0 0-5.25 5.25v.75a9.7 9.7 0 0 1-1.81 5.659 23 23 0 0 0 4.291.928 23 23 0 0 0 2.768.163 24 24 0 0 0 2.769-.163 23 23 0 0 0 4.291-.928 9.7 9.7 0 0 1-1.81-5.659v-.75A5.25 5.25 0 0 0 12 4.485m-6.75 5.25a6.75 6.75 0 0 1 13.5 0v.75c0 2.123.801 4.057 2.119 5.52a.75.75 0 0 1-.297 1.206c-1.544.57-3.16.99-4.831 1.244l.01.281a3.75 3.75 0 0 1-7.5 0l.01-.281a24.6 24.6 0 0 1-4.832-1.244.75.75 0 0 1-.297-1.206 8.22 8.22 0 0 0 2.119-5.52zm4.502 8.899-.002.101a2.25 2.25 0 0 0 4.5 0l-.002-.101-2.248.101a25 25 0 0 1-2.248-.101"
}));
const ForwardRef = forwardRef(SvgComponent);
export const BellIcon = ForwardRef;